import moment from 'moment';
import { estimatedGroceryFees, serviceCharges, SERVICE_TYPES } from '../const';

export const getServiceWeekday = ({ service_type, start_time }) => {
  // pass in service
  let day = moment(start_time).format('dddd');
  // If weekly or custom weekly make plural
  return (day += service_type !== 'occasion' ? 's' : '');
};

export const getServiceTimes = ({ start_time, end_time }) => {
  // pass in service
  // e.g. 10am-4pm
  return moment(start_time).format('ha') + '-' + moment(end_time).format('ha');
};

export const getServiceTotalEstimates = (portionSize) => {
  const totalCharge = Object.values(serviceCharges).reduce(
    (prev, cur) => prev + cur,
    0
  );
  const [small, large] = estimatedGroceryFees[portionSize];
  return [totalCharge + small, totalCharge + large];
};

export const isOccasion = (service) => {
  return [
    SERVICE_TYPES.OCCASION,
    SERVICE_TYPES.MARKETING_OCCASION,
    SERVICE_TYPES.CUSTOM_OCCASION,
    SERVICE_TYPES.COOKING_CLASS,
  ].includes(service.service_type);
}


// WEBPACK FOOTER //
// ./src/helpers/serviceUtil.js